import React, { FC } from 'react'
import GalleryItemConnector, {
  ConnectorProps as GalleryProps,
} from '../../../connectors/Gallery/Item'
import Image from './Image'
import PrintImage from './PrintImage'
import ViewInARoom from './ViewInARoom'
import {
  PRINT,
  CANVAS,
  CANVAS_WRAP_COLOR_WHITE,
  CANVAS_WRAP_COLOR_BLACK,
} from '../../../helpers/constants'
import { GalleryItem } from 'apps/saatchi/artdetail2/types'
import {
  GALLERY_ITEM_TYPE_ARTIST_VIDEO,
  GALLERY_ITEM_TYPE_IMAGE,
  GALLERY_ITEM_TYPE_VIEW_IN_A_ROOM_IMAGE,
} from 'apps/saatchi/artdetail2/constants'
import { updateDataLayer } from 'apps/saatchi/artdetail2/helpers'
import VideoPlayerPDP from 'components/SA/VideoPlayer/VideoPlayerPDP'

type Props = GalleryProps &
  GalleryItem & {
    hasHighFetchPriority: boolean
  }

const Component: FC<Props> = (props) => {
  const { galleryItemType, artworkId } = props

  const onVideoPlay = () => {
    updateDataLayer({
      event: 'video_start',
      video_action: 'play',
      video_id: artworkId,
    })
  }

  if (galleryItemType === GALLERY_ITEM_TYPE_ARTIST_VIDEO) {
    const { videoUrl } = props

    return <VideoPlayerPDP onVideoPlay={onVideoPlay} file={videoUrl} />
  }

  if (galleryItemType === GALLERY_ITEM_TYPE_VIEW_IN_A_ROOM_IMAGE) {
    return (
      <div data-type='vir'>
        <ViewInARoom
          galleryDimensions={props.galleryDimensions}
          imageUrl={props.imageUrl}
          selectedFrameOption={props.selectedFrameOption}
          selectedCanvasWrapColorOption={props.selectedCanvasWrapColorOption}
          selectedProduct={props.selectedProduct}
          title={props.title}
          category={props.category}
          subject={props.subject}
          styles={props.styles}
          artistName={props.artistName}
        />
      </div>
    )
  }

  const {
    imageUrl,
    selectedFrameOption,
    selectedCanvasWrapColorOption,
    selectedProduct,
    title,
    hasHighFetchPriority,
    category,
    subject,
    styles,
    artistName,
  } = props

  const getCanvasWrapColor = ():
    | typeof CANVAS_WRAP_COLOR_WHITE
    | typeof CANVAS_WRAP_COLOR_BLACK
    | null => {
    if (selectedProduct.material !== CANVAS) {
      return null
    }

    return selectedCanvasWrapColorOption?.title || CANVAS_WRAP_COLOR_BLACK
  }

  if (galleryItemType === GALLERY_ITEM_TYPE_IMAGE && props.type === PRINT) {
    const { height, width, material } = selectedProduct
    return (
      <div data-type='print'>
        <PrintImage
          {...{
            alt: title,
            frameColor: selectedFrameOption?.title,
            canvasWrapColor: getCanvasWrapColor(),
            height,
            imageUrl,
            type: material,
            width,
            hasHighFetchPriority,
            category,
            subject,
            styles,
            artistName,
          }}
        />
      </div>
    )
  }

  return <Image {...props} />
}

export default GalleryItemConnector(Component)
